import { useIntl } from 'react-intl';

import { Row, Col, Form, Input, FormInstance } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import {
  CompaniesInfiniteSelectField,
  InputDecimal,
} from '@/components/_common';
import AreasInfiniteSelectField from '@/components/_common/AreasInfiniteSelectField';

interface FormValues {
  description: string;
  companiesIds: Array<number>;
  area: string;
}

interface Props {
  form?: FormInstance<FormValues>;
}

function TaskReportForm({ form }: Props) {
  const intl = useIntl();

  return (
    <Form form={form}>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={14}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'tasks.modal.report.form.description',
            })}
            name="description"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={10}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'tasks.modal.report.form.area',
            })}
            name="area"
          >
            <AreasInfiniteSelectField isListArea allowClear />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'tasks.modal.report.form.companies',
            })}
            name="companiesIds"
          >
            <CompaniesInfiniteSelectField mode="multiple" />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'tasks.modal.report.form.time',
            })}
            name="initialTimeRange"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'tasks.modal.report.form.timeUpUntil',
            })}
            name="endTimeRange"
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default TaskReportForm;
